import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
import { StoreRepositoryService } from "../../store/store-repository.service";
import { TranslatePipe } from "@ngx-translate/core";
@Component({
    selector: "app-jackpot-info-popup",
    templateUrl: "./jackpot-info-popup.component.html",
    styleUrls: ["./jackpot-info-popup.component.scss"],
    standalone: true,
    imports: [TranslatePipe],
})
export class JackpotInfoPopupComponent implements OnInit {
  jackpotPopupData: any;
  constructor(
    private matDialog: MatDialog,
    private router: Router,
    private jackpotTriggerService: JackpotTriggersService,
    private storeService: StoreRepositoryService
  ) { }

  ngOnInit(): void {
    this.jackpotTriggerService?.getActivateTriggerPopupData().subscribe((ref: any) => {
      this.jackpotPopupData = ref?.jackpot_triggers?.page_1;
    });
  }

  goToSyndicate() {
    this.matDialog.closeAll();
    this.storeService.showJackpotPromoSection$.next(true);
    this.router.navigateByUrl(this.jackpotPopupData?.button_link);
  }
}
